/* Afkar Plus — drawer hero: quick add + slide rotation (BeyondADS, 23 Sep 2026) */
(function () {
  'use strict';
  if (window.__adhLoaded) return; // the phone hero loads this file too
  window.__adhLoaded = true;

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg, linkHref, linkText) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'adh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toastEl.appendChild(span);
    if (linkHref) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText || 'View cart';
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- quick add (delegated, siblings not nested) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-adh-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.classList.contains('is-busy')) return;
    var id = btn.getAttribute('data-variant');
    if (!id) return;
    var root = btn.closest('[data-adh]');
    var addUrl = (root && root.getAttribute('data-add-url')) || (window.routes && window.routes.cart_add_url) || '/cart/add';
    var cartUrl = (root && root.getAttribute('data-cart-url')) || (window.routes && window.routes.cart_url) || '/cart';
    var name = btn.getAttribute('data-name') || 'Item';

    btn.classList.add('is-busy');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    fd.append('sections', 'cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);

    var ctrl = null, timer = null;
    try { ctrl = new AbortController(); timer = setTimeout(function () { ctrl.abort(); }, 15000); } catch (_) {}

    fetch(addUrl, {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) throw new Error(j.description || j.message || 'rejected');
        // refresh the header cart bubble from the sections payload
        try {
          if (j.sections && j.sections['cart-icon-bubble']) {
            var host = document.getElementById('cart-icon-bubble');
            if (host) {
              var doc = new DOMParser().parseFromString(j.sections['cart-icon-bubble'], 'text/html');
              var inner = doc.querySelector('.shopify-section') || doc.body;
              host.innerHTML = inner.innerHTML;
            }
          }
        } catch (_) {}
        try {
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'afkar-drawer-hero', productVariantId: id, cartData: j });
          }
        } catch (_) {}
        // hand off to a cart drawer / notification if the theme has one
        try {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (cart && typeof cart.renderContents === 'function' && j.sections && cart.getSectionsToRender) {
            var need = cart.getSectionsToRender().map(function (s) { return s.id; });
            var have = need.every(function (sid) { return j.sections[sid]; });
            if (have) cart.renderContents(j);
          }
        } catch (_) {}
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
        toast(name + ' added to your cart', cartUrl, 'View cart');
      })
      .catch(function () {
        toast('Could not add ' + name + ' — please try again');
      })
      .then(function () {
        if (timer) clearTimeout(timer);
        btn.classList.remove('is-busy');
      });
  }, true);

  /* ---------- "scroll to enter" cue ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-adh-scroll]'); if (!a) return;
    e.preventDefault();
    var sec = a.closest('.shopify-section') || a.closest('[data-adh]');
    var y = sec ? sec.getBoundingClientRect().bottom + window.pageYOffset : window.innerHeight;
    var head = document.querySelector('.section-header.shopify-section-group-header-group, .shopify-section-header, header.header');
    if (head && getComputedStyle(head).position === 'sticky') y -= head.offsetHeight;
    window.scrollTo({ top: Math.max(0, y - 8), behavior: 'smooth' });
  }, true);

  /* ---------- slides (one accumulator drives fill + change) ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initRoot(root) {
    if (root.__adhInit) return;
    root.__adhInit = true;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-adh-slide]'));
    var n = slides.length;
    var cur = root.querySelector('[data-adh-cur]');
    var fill = root.querySelector('[data-adh-fill]');
    if (n < 2) {
      if (fill) fill.style.transform = 'scaleX(1)';
      var seg0 = root.querySelector('.adh-counter__seg'); if (seg0) seg0.classList.add('is-on');
      return;
    }
    var auto = root.getAttribute('data-auto') === 'true';
    var dur = Math.max(2, parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, elapsed = 0, last = null, raf = null;

    var segs = Array.prototype.slice.call(root.querySelectorAll('.adh-counter__seg'));
    function show(k) {
      i = (k + n) % n;
      slides.forEach(function (s, idx) { s.classList.toggle('is-on', idx === i); });
      if (cur) cur.textContent = pad(i + 1);
      segs.forEach(function (sg, idx) {
        sg.classList.toggle('is-on', idx === i);
        sg.classList.toggle('is-done', idx < i);
        var bar = sg.querySelector('i');
        if (bar) { bar.style.transform = 'scaleX(0)'; if (idx === i) bar.setAttribute('data-adh-fill', ''); else bar.removeAttribute('data-adh-fill'); }
      });
      fill = root.querySelector('[data-adh-fill]');
      elapsed = 0;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-adh-go]'); if (!b) return;
      e.preventDefault(); show(parseInt(b.getAttribute('data-adh-go'), 10) || 0);
    });
    function tick(ts) {
      raf = requestAnimationFrame(tick);
      if (document.hidden) { last = ts; return; }
      if (last == null) last = ts;
      var dt = Math.min(ts - last, 250);
      last = ts;
      elapsed += dt;
      if (fill) fill.style.transform = 'scaleX(' + Math.min(1, elapsed / dur) + ')';
      if (elapsed >= dur) show(i + 1);
    }
    show(0);
    if (auto && !reduce) raf = requestAnimationFrame(tick);
    if (!auto || reduce) { if (fill) fill.style.transform = 'scaleX(1)'; }

    // swipe on touch
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 48) show(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });

    root.__adhTick = function () { show(i + 1); };
  }

  function boot() { document.querySelectorAll('[data-adh]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
